module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-707-retro-min.02fb282b.jpg";